import axios, { getAccessToken, getParticipantInfo } from '../../../features/FocalPoint/Shared/axios'

export const requestGetApi = async (url) => {
  const participant = getParticipantInfo()

  const headers = {
    'Authorization': `Bearer ${getAccessToken()}`,
    'campaignId': `${participant['custom:campaign_id']}`,
    'catalogId': `${participant['custom:catalog_id']}`
  }

  const response = await axios
    .get(url, { headers })
    .then((res) => {
      return res.data
    })
    .catch((err) => {
      console.log(err)
      return false
    })

  return response
}

export const validNumber = (number) => {
  if (number) return number.replace(/[^\d+]/g, '')
  return 0
}

export const validLoginInput = (number) => {
  if (number) return number.replace(/[^\d+]/g, '')
  return ''
}

export const validChangeName = (number) => {
  if (number) return number.replace(/[^a-z\s]/gi, '')
  return ''
}

export const validNameInput = (name) => {
  let nameInputed = name.trim().replace(/[^a-z\s]/gi, '').split(' ')
  if (nameInputed.length > 1) return true
  return false
}

export const validEmailInput = (email) => {
  let emailInputed = /^[^\s@]+@[^\s@]+[.]+[^\s@]+$/.test(email)
  if (emailInputed) return true
  return false
}

export const parseOptions = {
  header: true,
  skipEmptyLines: true,
  transformHeader: header =>
    header
      .toLowerCase()
      .replace(/\W/g, '_')
}



// WEBPACK FOOTER //
// ./src/features/FocalPoint/Shared/utils.js